<button [ngClass]="disabled ? 'disabled' : ''" (click)="emitAction()" class="option__type">
  <fa-icon [icon]="icon" class="option__type__icon"></fa-icon>
  <span class="option__type__name fs__sm fw__500">{{ text }}</span>
  <fa-icon [icon]="iconArrow"></fa-icon>
</button>
